// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import axios from 'axios';
import router from './router';
import Router from 'vue-router';
import Vant from 'vant';
import 'vant/lib/index.css';
import '@/assets/css/reset.css';
import '../node_modules/swiper/css/swiper.css';
import 'vue-video-player/src/custom-theme.css';
import VueVideoPlayer from 'vue-video-player';
import filters from './filters/index';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import VueCookie from 'vue-cookie';
import Vconsole from 'vconsole';
import Store from '@/store/index.js';
// import { xm_bi } from '@/assets/xm_h5_analysis.js';

// 异步加载小马统计js文件
const xm_bi = import('@/assets/xm_h5_analysis.js');
let opt = {
  appKey: 'P6NEM3JU12KR',
  //这里是示例url，实际业务自行替换，无需加http(s)://前缀
  requestUrl: 'xmaccess.tfgreenroad.com',
  //prod上报，dev不上报
  env: 'prod',
  //可选配置, 业务本身的用户id
  // userId: 'user_id',
  //可选配置, 自动上报，true时初始化即上报，并监听单页面hashchange，popstate触发上报
  statAutoReport: true,
  //可选配置，页面性能监控
  performanceMonitor: true,
  //可选配置，将采集该参数下的值做渠道分析，可自定义某参数做渠道
  channelTag: 'adtag',
  //可选配置，页面参数分析，true时参数分开上报，false则上报完整的url,默认为true
  analysisUrlParam: true,
}
xm_bi.then(() => {
  //版本变更，不再使用new class方式
  window.xm_bi.init(opt)
})
Vue.use(Vant).use(VueVideoPlayer).use(VueAwesomeSwiper).use(VueCookie);

// 是否为测试环境
export const isDebug = false;
//是否打开vconsole
const isConsole = false;

Vue.config.productionTip = false;
const host = isDebug ? 'https://tapp.tfgreenroad.com' : 'https://app-cdc.tfgreenroad.com';
//2.0微信授权接口域名
Vue.prototype.newUrlHost = host;
Vue.prototype.SHDetails = isDebug ? 'https://tfe.tfgreenroad.com/fwpt-h5-dc/index.html#/detail/' : 'https://fe.tfgreenroad.com/fwpt-h5-dc/index.html#/detail/';
Vue.prototype.SaiShi = isDebug ? 'https://tgr.wiiqq.com' : 'https://oss.tfgreenroad.com';
// 超时处理
axios.defaults.timeout = 15000;
// 2.0 请求时使用
const instance = axios.create({
  baseURL: host,
  headers: {
    'client': '2',
    'user_id': localStorage.getItem('uid') || ''
  },
  withCredentials: true,
})
// 对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中
let jsApi = new Promise((resolve, reject) => {
  instance.post(
    `/appserver/v1/user/get_jsapi_config?url=${encodeURIComponent(
      location.href.split('#')[0],
    )}&jsapi=${VueCookie.get('w_skey')}`,
  ).then(data => {
    const locationData = JSON.parse(data.data.data.jsapi_config);
    resolve(locationData);
  }).catch((e) => {
    reject(e);
  })
});
jsApi.then(locationData => {
  wx.config({
    debug: locationData.debug, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
    appId: locationData.appId, // 必填，公众号的唯一标识
    timestamp: locationData.timestamp, // 必填，生成签名的时间戳
    nonceStr: locationData.nonceStr, // 必填，生成签名的随机串
    signature: locationData.signature, // 必填，签名
    jsApiList: [
      'openLocation',
      'scanQRCode',
      'getLocation',
      'startRecord',
      'stopRecord',
      'translateVoice',
      'checkJsApi',
      'updateAppMessageShareData',
      'updateTimelineShareData',
      'chooseWXPay',
      'getNetworkType',
      'hideAllNonBaseMenuItem'
    ], // 必填，需要使用的JS接口列表
  });
}).catch(e => {
  console.error(e, 'get_jsapi_config------error');
})

if (isConsole) {
  const vConsole = new Vconsole()
  Vue.use(vConsole)
}

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.prototype.$request = instance;
Vue.prototype.ImagesFun = Store;
Vue.prototype.footerActive = 0;
// 全局创建微信授权方法
Vue.prototype.wxAuth = function (state = 'wxAuth') {
  window.location.href = `${this.newUrlHost}/appserver/v1/user/authorize?redirect_uri=${encodeURIComponent(window.location.href)}&state=${state}`;
}
// js sdk 跳转地图方法
Vue.prototype.openLocation = function (lat, lng, title, address) {
  wx.openLocation({
    latitude: parseFloat(lat), // 纬度，浮点数，范围为90 ~ -90
    longitude: parseFloat(lng), // 经度，浮点数，范围为180 ~ -180。
    name: title, // 位置名
    address: address, // 地址详情说明
    scale: 13, // 地图缩放级别,整形值,范围从1~28。默认为最大
    infoUrl: '' // 在查看位置界面底部显示的超链接,可点击跳转
  })
}

/**
 * 路由 生命周期--before
 */
// let filterName = ['bindingPhone']  // 需要绑定手机号码访问的页面路由name
router.beforeEach((to, from, next) => {

  // if (window.location.href.includes('state=wxAuth')) {  // 此条件成立，意味着已授权跳转回来
  //   console.log(VueCookie.get('w_uid') !== 0 && to.meta.wxAuth, "VueCookie.get('w_uid') !== 0 && to.meta.wxAuth")
  //   if (VueCookie.get('w_uid') == 0 && to.meta.wxAuth) {  // 意味着未绑定手机号码
  //     next({ name: 'bindingPhone', query: { toName: to.name, toQuery: to.query } });
  //   } else {  // 清除无用字符串
  //     if (to.name != "bindingPhone") {
  //       let href = window.location.href;
  //       href = window.location.href.slice(0, window.location.href.indexOf('?auth_code='));
  //       href = href + window.location.href.slice(window.location.href.indexOf('#/'), window.location.href.length);
  //       window.location.href = href;
  //     }
  //   }
  // }

  // 控制footer active的index状态
  if (to.name === 'HomePage') {
    Vue.prototype.footerActive = 0;
  } else if (to.name === 'userInfo') {
    Vue.prototype.footerActive = 1;
  }

  if (from.name == 'HomePage') {   // 缓存首页滚动位置
    console.log('触发缓存首页滚动位置',to);
    console.log($('.newHomePage').get(0).scrollTop,'document.getElementById().scrollTop')
    sessionStorage.setItem('homeScroll', $('.newHomePage').get(0).scrollTop);
  }

  if (from.name == "newAllVideoPictures") {  // 是否来自图集页(因名片页无法监听路由跳转 故用此方法解决)
    if (to.name == "greenCard" || to.name == "scenicSpot") { // 绿道名片
      to.meta.currentTime = sessionStorage.getItem('allVideoCurrentTime');  // 全部视频播放页当前currentTime
      to.meta.playStatus = Boolean(sessionStorage.getItem('playStatus'));   // 视频当前播放状态
      to.meta.muted = Boolean(sessionStorage.getItem('muted'));    // 是否静音
    } else {
      to.meta.currentTime = '';
      to.meta.playStatus = '';
      to.meta.muted = '';
    }
  } else {
    // console.error('移除缓存');
    to.meta.currentTime = '';
    to.meta.playStatus = '';
    to.meta.muted = '';
    sessionStorage.removeItem('allVideoCurrentTime');
    sessionStorage.removeItem('playStatus');
    sessionStorage.removeItem('muted');
  }

  if (to.name == "HomePage") {// 路由缓存
    to.meta.keepAlive = true;
    next();
  } else {
    next();
  }
})
/**
 * 路由 生命周期--after
 */
router.afterEach((to, from, next) => {
  if (to.name == 'HomePage') {
    // console.log('不重置位置');

  } else {
    // console.log('重置滚动条');
    // console.log(document.getElementById('app'),'appDom')
    document.getElementById('app').scrollTo(0, 0);
  }

  // 标题文本替换
  document.title = to.meta.title || '';
  // 控制分享按钮的隐藏
  if (to.meta.hideShare) {
    wx.hideOptionMenu();
  } else {
    wx.showOptionMenu();
  }
})
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

new Vue({
  router,
  render: h => h(App)
}).$mount("#app")